export var EDeviceType;

(function (EDeviceType) {
  EDeviceType["Desktop"] = "desktop";
  EDeviceType["Phone"] = "phone";
  EDeviceType["Tablet"] = "tablet";
})(EDeviceType || (EDeviceType = {}));